(function (){
    'use strict';

    angular
        .module('services')
        .service('LanguagesService', LanguagesService);

    LanguagesService.$inject = ['$http', 'API_BASE'];

    function LanguagesService ($http, API_BASE) {
        var service = this;

        service.getAllLanguages = getAllLanguages;

        function getAllLanguages() {
            return $http.get(API_BASE + '/languages/list');
        }

    }
})();